import {DownloadType} from '@/enum/download_type';

const heading = 'heading';
const paragraph = 'paragraph';

export default {
    hello: 'Hello',
    and: 'and',
    or: 'or',
    continue: 'Continue',
    close: 'Close',
    cancel: 'Cancel',
    yearWeek: '{1}. week of {0}',
    unexpectedError: 'An unexpected error has occurred. Please try again.',
    createdBy: "Created in SEOWRITEE",
    affiliate: "Sign up to our affiliate program and get rewarded for every user you bring to our application!",
    unknownError: "Unexpected error occurred!",

    profile: {
        title: 'Your account',
        upgradeTitle: 'Upgrade your plan',
        upgradeSubtitle: 'Move to a higher plan anytime. Unused billing period is handled by Stripe.',
        articlesTotal: 'Articles in library',
        articlesThisPeriod: 'This billing period',
        avgSeo: 'Average SEO score',
        bestSeo: 'Best SEO score',
        generated: 'Written by AI',
        analyzed: 'Analyzed from URL',
        published: 'With published URL',
        extraCredits: 'Extra credits',
        freeAnalyses: 'Free analyses this month',
        freeAnalysesHint: '{0} of {1} left. Each URL article analysis uses 1. Resets on the 1st of the month. Generating new AI articles requires a paid plan.',
        recent: 'Recent articles',
        noArticles: 'You have not created any articles yet.',
        loadingStats: 'Loading your stats…',
        statsError: 'Could not load article statistics.',
        statsSample: 'Averages are based on your {0} most recent articles.',
        openArticle: 'Open',
        noScore: '—',
        typeGenerate: 'Generate',
        typeAnalyze: 'Analyze',
        firstArticle: 'First article',
        seeAllArticles: 'All articles',
    },

    save: 'Save',
    delete: 'Delete',
    settings: 'Settings',
    languageSelector: {
        label: 'Language',
        cs: 'Čeština',
        en: 'English',
    },

    subscriptions: {
        title: 'The application is now ready to write you a complete article perfectly optimized for internet search engines and attractive for readers.',
        subTitle: 'Select your subscription plan, pay online and start immediately generate quality SEO content.',
        pricingTitle: 'Pricing plans',
        pricingSubtitle: 'Every plan includes AI writing, SEO scoring and keyword analysis. Pick the volume that fits how often you publish.',
        currentPlan: 'Your current plan',
        popular: 'Popular',
        getStarted: 'Get started',
        startFree: 'Start for free',
        contactSales: 'Contact us',
        faqTitle: 'Frequently asked questions',
        faqChangeQ: 'Can I change or cancel anytime?',
        faqIncludedQ: 'What is included in every plan?',
        faqBusinessQ: 'Do you offer a custom Business plan?',
        affiliateTitle: 'Earn with SEOWRITEE',
        affiliateCta: 'Join the affiliate program',
        oneTimeSubtitle: 'Need extra articles this month without changing your plan?',
        mustAcceptTerms: 'Please accept the terms of service before continuing.',
        manageBilling: 'Manage billing',
        perMonthShort: 'per month',
        changePlanCta: 'Change plan',

        perMonth: '{0} / month',
        inspiration: 'article',
        upToInspirations: '{0} articles per month',
        keywords: '{0} keywords in 4 groups',
        buy: 'Buy',

        allPlansInclude: 'All subscriptions include',
        mustChoosePlan: 'You need to choose a subscription!',
        continueWithPlan: 'Continue with \'{0}\'',
        noPlan: 'no subscription',
        activePlan: 'active',
        changePlan: 'change',
        choosePlan: 'choose',
        chosenPlan: 'chosen',
        usageTooltip: 'You\'ve created {0} out of {1} articles this period',
        unlimitedUsageTooltip: 'In this period, you\'ve created {0} articles',
        planRenewTooltip: 'The counter will reset',
        planWillBeCancelled: 'You subscription will end',
        noInspirationsLeftThisPeriodUpgradeToContinue: {
            title: 'You\'ve Used All Your Articles!',
            content: 'You\'ve used all available articles for this period. To continue, upgrade to a higher plan or purchase a one-time article package.',
            action: 'View Plans'
        },
        manageSubscription: 'Manage or upgrade your subscription or billing information',
        oneTimePacks: 'One-time packages of articles',

        usage: {
            freeAnalyses: '{0} of {1} free analyses remaining this month',
            freeAnalysesReset: 'Resets on the 1st of each month',
            freeAnalysesExplain: 'The free plan includes {max} URL article analyses each calendar month. You have used {used} this month and have {left} left. Generating new AI articles requires a paid plan.',
            freeAnalysesNone: 'You have no free analyses left this month. More arrive on the 1st of next month, or you can upgrade.',
            articlesRemaining: '{0} of {1} articles remaining this period',
            unlimitedArticles: '{0} articles created this period',
            warningLimitReached: 'Warning: You\'ve reached {0} articles - nearing monthly limit',
            usingExtraInspirations: 'Monthly limit reached - now using extra credits',
            extraInspirationsExplain: 'You have {0} extra credits for content generation',
            extraInspirationsAfterPlan: '{0} extra credits available',
            extraInspirationsAfterLimit: '{0} extra credits can be used after {1} articles',
            extraInspirationsAvailable: '{0} extra credits remaining'
        },
        barLabel: 'Plan usage',
        barLabelFree: 'Free analyses',
        barTooltip: 'Profile and plan usage',
        usageLoading: 'Loading plan',
        usageLoadingTooltip: 'AI Lucy is loading your plan. Usage appears once the plan is known.',

        freeAnalyses: {
            title: '{0} Free Analyses Monthly',
            description: 'Analyze your existing content and improve SEO score',
            remaining: '{0} of {1} analyses left this month',
            exhausted: {
                title: 'No analyses left this month',
                content: 'You\'ve used all {0} free analyses for this month. Upgrade to continue analyzing and generating content!',
                action: 'Upgrade Now'
            },
            resetsOn: 'Resets on the 1st of each month'
        },

        paywall: {
            generateRequiresPlan: {
                title: 'Activate a Plan to Generate Content',
                content: 'Generating SEO articles with AI requires an active subscription. Choose a plan and start creating quality content today!',
                action: 'Choose Plan'
            },
            polishRequiresPlan: {
                title: 'Upgrade to Refine Content',
                content: 'AI content refining is available for paid subscribers. Upgrade to refine your articles!',
                action: 'View Plans'
            },
            enhanceRequiresPlan: {
                title: 'Upgrade to Enhance Content',
                content: 'AI content enhancement is available for paid subscribers. Upgrade to expand your articles!',
                action: 'View Plans'
            }
        },

        upgradeToBusiness: {
            title: 'Upgrade to Business Plan',
            content: 'You\'ve reached the threshold for heavy writers ({0} articles). Consider upgrading to our Business plan for better rates!',
            action: 'Upgrade to Business'
        },

        free: 'free',
        individual: 'individual',
        individualContact: 'We will arrange an individual price with you. Please contact us by email rudolf.sehnal@seowritee.com',

        features: {
            aiWriting: 'Up to several hundred thousand words written by AI',
            seoScore: 'SEO score calculated from 20+ parameters',
            instructions: 'Detailed step-by-step instructions',
            export: '4 types of export to your web page',
            chatGpt: 'ChatGPT for content tuning',
            keywordAnalysis: 'Automatic keyword analysis',
            inspiration: 'Inspiration from TOP10 articles'
        },

        usageLimit: {
            warning: 'You\'re a really heavy above-average writer. Great, we\'re rooting for you, there\'s never enough ' +
                'quality content :-) You can still keep generating articles, but if you continue at this rate for the next ' +
                'month, we\'ll arrange to upgrade you to the BUSINESS rate. Thank you for understanding and using SEOWRITEE.',
            stop: 'We\'re still rooting for you in your intense writing, but you\'ve already exceeded ' +
                'the limit of even the most intense writers :-). If you need to keep writing this month, ' +
                'pay for your next articles with a one-time payment and arrange a price for an BUSINESS ' +
                'license for the next month with us at rudolf.sehnal@seowritee.com.',
            useExtraInspiration: 'Use extra article ({0} left)',
            buyExtraInspirations: 'Buy extra articles',
        },

        terms: {
            IAccept: 'I accept',
            termsOfService: 'Terms of service',
            privacyPolicy: 'Privacy policy',
            info: 'I am aware, that payment will recur every month till I unsubscribe'
        },

        change: 'You can upgrade or downgrade your plan anytime, no additional fees are incurred. No contract is needed, you can cancel at any time by simply stopping your payments.',
        upgradeToUse: 'Choose any subscription plan to use this feature!',

        list: {
            title: 'Write an article people find in search results and in AI answers.',
            items: {
                1: 'To generate the article text, just enter a keyword and AI Lucy will write optimized text in one click.',
                2: 'Or insert the URL of the existing article, and improve it based on the SEO analysis.',
                3: 'The application creates a keyword analysis and writes the content of the article based on the keywords.',
                4: 'The written text also includes answers to the most frequently asked questions that people are interested in.',
                5: 'You will get inspiration to improve all parts of the article from the best optimized text on the internet.',
                6: 'You can easily edit the written title, meta description, H1 to H6 headings, bodycopy etc.',
                7: 'The application automatically monitors over 20 SEO factors important for high search engine rankings.',
                8: 'Then you just export the article and upload it to the web.'
            },
            targetsLabel: 'Templates for search and AI chats',
            generate: {
                title: 'Write a new article',
                subtitle: 'From a keyword — copy for Google, Gemini, ChatGPT, Perplexity and Copilot',
                items: {
                    1: 'Pick a structure template: Universal SEO, AI Overviews, Gemini, ChatGPT, Perplexity or Copilot',
                    2: 'AI Lucy builds a brief from live AI chat answers, follow-up questions and facts that get cited',
                    3: 'A full article with a direct answer, clear H2s and FAQ that AI replies reuse',
                    4: 'While you write, it tracks SEO score and the chance AI will lift the text into an answer',
                }
            },
            analyze: {
                title: 'Improve an existing article',
                subtitle: 'From a URL — stronger in search and in AI chats',
                items: {
                    1: 'We extract the page and score 20+ SEO factors, including an AI visibility estimate',
                    2: 'AI Lucy shows what to add so AI Overviews and chats can cite the article',
                    3: 'The same template and tone as a new article — AI Overviews, Gemini, ChatGPT…',
                    4: 'Export to DOCX, HTML or clipboard',
                }
            },
        },

        plansLoadingError: {
            title: 'Error while loading plan prices.',
        }
    },
    newContentAvailable: 'New app version is available!',
    refresh: 'Refresh',
    logout: 'Log out',

    register: 'Register and generate or analyze an article for free!',
    noCardRequired: 'No credit card required.',
    loginTagline: 'Copywriter for search engines and AI chats',

    auth: {
        signInWithGoogle: 'Sign in with Google',
        signInWithEmail: 'Sign in with email',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm password',
        signIn: 'Sign in',
        createAccount: 'Create account',
        noAccount: "Don't have an account?",
        haveAccount: 'Already have an account?',
        tosPrefix: 'By continuing, you accept our',
        termsLink: 'Terms of Service',
        privacyLink: 'Privacy Policy',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        forgotPassword: 'Forgot password?',
        resetTitle: 'Reset password',
        resetSubtitle: "Enter your account's email. We'll send you a link to set a new password.",
        sendResetLink: 'Send link',
        resetSent: 'If an account with this email exists, we have sent it a link to set a new password. Check your spam folder too.',
        backToSignIn: 'Back to sign in',
        errors: {
            userNotFound: 'No account exists with this email.',
            wrongPassword: 'Incorrect password.',
            invalidEmail: 'Enter a valid email address.',
            emailAlreadyInUse: 'An account with this email already exists. Sign in instead.',
            weakPassword: 'Password must be at least 6 characters.',
            tooManyRequests: 'Too many attempts. Try again later.',
            invalidCredential: 'Incorrect email or password.',
            userDisabled: 'This account has been disabled.',
            network: 'Network error. Check your connection and try again.',
            passwordMismatch: 'Passwords do not match.',
            passwordRequired: 'Enter your password.',
            googleFailed: 'Google sign-in failed. Try again, or use email.',
            popupBlocked: 'The Google sign-in window was blocked. Allow popups for this page and try again.',
        },
    },

    unsavedChanges: {
        title: 'Unsaved changes',
        text: 'Do you really wish to leave?',
        stay: 'Stay',
        saveAndLeave: 'Save and leave',
        leave: 'Leave'
    },

    steps: {
        step: 'Step',
        initForm: 'Brief, template and keyword',
        selectKeyword: 'Keyword selection',
        writeArticle: 'Article writing',
    },

    createBrief: {
        title: 'New article',
        badge: 'AI generator',
        subtitle: 'Complete the steps in this order. After you confirm, you can generate the article immediately, or first refine paragraphs using the keyword analysis running in the background.',
        analyzeTitle: 'Analyze an article from a URL',
        analyzeBadge: 'SEO edit',
        analyzeSubtitle: 'Complete the steps in this order. We extract the page, then you can improve it with the same template and tone.',
        optional: 'Optional',
        templateLabel: 'Article template',
        marketLabel: 'Country, language and focus keyword',
        steps: {
            url: {
                title: 'Paste the article URL',
                help: 'Enter the public URL of the page you want to improve. We extract its text and use it as the starting point.',
            },
            brief: {
                title: 'Describe what the article should cover',
                help: 'The more precise the brief, the better AI covers the right points. State the goal, main topics, comparisons, practical tips or FAQ.',
                helpAnalyze: 'Briefly say what the page is about and what the rewrite should keep or strengthen. AI uses this together with the extracted text.',
            },
            keyword: {
                title: 'Choose country, language and focus keyword',
                help: 'The article is written in this language for this market. Start typing a phrase and pick a suggestion with a suitable search volume. You can still refine the focus keyword later.',
            },
            template: {
                title: 'Choose a structure template',
                help: 'The template sets how the text is built — a direct answer, follow-up questions, facts that can be cited. Google AI Overviews and AI Mode share one card; Gemini is its own chat target next to ChatGPT, Perplexity and Copilot.',
            },
            style: {
                title: 'Set tone, audience and depth',
                help: 'These fields have defaults you can keep or change. Extra keywords are optional — if you add them, AI weaves them into the paragraphs.',
            },
        },
        focusKeyword: 'Focus keyword',
        focusKeywordHint: 'e.g. how to choose a heat pump',
        urlLabel: 'Article URL',
        briefLabel: 'Topic description and brief',
        briefHint: 'What the article should cover',
        briefExample: 'e.g. a beginner guide, type comparison, cost ranges, pros and cons, practical tips and FAQ.',
        secondaryLabel: 'Extra keywords for AI',
        secondaryPlaceholder: 'Add another keyword phrase…',
        secondaryCount: '{0} added',
        secondaryHint: 'Add extra phrases you want AI to weave into the paragraphs.',
        addKeyword: 'Add',
        toneLabel: 'Tone of voice',
        audienceLabel: 'Audience',
        depthLabel: 'Article depth',
        submit: 'Continue to keyword analysis',
        submitAnalyze: 'Continue to analysis',
        nextStepHint: 'Next: write the article now, or refine sections using the four keyword groups.',
        nextStepHintAnalyze: 'Next we extract the page and prepare the rewrite from your brief and template.',
        refineSettings: 'Template and tone before generating',
        templates: {
            universal: {
                title: 'Universal SEO',
                blurb: 'A classic article with a direct answer, clear H2s and FAQ. A solid base for search and AI citations.',
            },
            aiOverviews: {
                title: 'AI Overviews',
                blurb: 'A direct answer in the first sentences, then H2s for follow-ups: how to choose, compare, who it is for. Short citable passages, lists and FAQ for Google AI Overviews and AI Mode.',
            },
            aiMode: {
                title: 'AI Overviews',
                blurb: 'A direct answer in the first sentences, then H2s for follow-ups: how to choose, compare, who it is for. Short citable passages, lists and FAQ for Google AI Overviews and AI Mode.',
            },
            gemini: {
                title: 'Gemini',
                blurb: 'A structured chat answer: tables, lists and self-contained passages Gemini can quote. Clear criteria, numbers and a verifiable fact in each block.',
            },
            chatgpt: {
                title: 'ChatGPT',
                blurb: 'Conversational and quotable. Answer first, then steps and FAQ that a chat reply can reuse.',
            },
            perplexity: {
                title: 'Perplexity',
                blurb: 'Facts, numbers and short paragraphs with one clear claim. Built to be cited in AI search.',
            },
            copilot: {
                title: 'Copilot',
                blurb: 'Answer first, question-style H2s and self-contained passages with no “as above”. Facts, dates and verifiable sources Copilot can lift into recommendations.',
            },
        },
        tones: {
            professional: 'Professional and readable',
            friendly: 'Friendly and clear',
            expert: 'Expert and precise',
            practical: 'Practical, step by step',
        },
        audiences: {
            general: 'General public and customers',
            beginners: 'Beginners',
            professionals: 'Practitioners',
            customers: 'People about to buy',
        },
        depths: {
            short: 'Short article (~800 words)',
            standard: 'Standard article (~1,200 words)',
            deep: 'In-depth article (~2,000 words)',
        },
    },

    articleChat: {
        stepOf: 'step {0} of {1}',
        greeting: 'Hello, I am AI Lucy. I will help you prepare the article.',
        greetingAnalyze: 'Hello, I am AI Lucy. I will help you improve the article you already have.',
        urlQuestion: 'Paste the article address.',
        urlLead: 'Enter the public address of the page. We will take the text from it and use it as the starting point.',
        urlLabel: 'Article URL (required)',
        urlExample: 'For example: https://www.yourwebsite.com/article-to-improve',
        urlEmpty: 'Paste the article address. Then you can continue.',
        urlKeyHint: 'Enter continues.',
        historyUrl: 'Article address',
        loadedQuestion: 'The page is loaded.',
        loadedLead: 'AI Lucy kept the title and the headings that stayed from the page. Check them and continue.',
        loadedFrame: 'What we loaded',
        loadedTitleLabel: 'Page title',
        loadedTitleMissing: 'The page did not include a title.',
        loadedOutlineLabel: 'Headings that were kept',
        loadedStays: 'The original text stays until you confirm the improvement on the article page.',
        loadedReading: 'AI Lucy is reading the page.',
        loadedKeyHint: 'Enter continues.',
        historyLoaded: 'Loaded page',
        goalQuestion: 'What should change on the page?',
        goalLead: 'Polish is already selected. AI Lucy asks what the edit should do. Continue opens the check of this setup.',
        goalFrame: 'Edit goal',
        goalKeyHint: 'Arrow keys move between the cards. Enter selects the card. Another Enter or Continue goes to the next step.',
        goalSectionsLabel: 'Sections to rewrite',
        goalNeedSection: 'Select at least one section. Then you can continue.',
        goalNoSections: 'This page has no H2 heading to select. Choose another edit goal.',
        historyGoal: 'Edit goal',
        goals: {
            polish: {
                title: 'Polish for search and AI',
                blurb: 'Keeps the text and the headings. It polishes the title, the opening, the keywords, and the common questions.',
            },
            fill: {
                title: 'Add the missing topics',
                blurb: 'Adds one to three new sections for topics that are missing. The current sections stay.',
            },
            rewrite: {
                title: 'Rewrite the selected sections',
                blurb: 'Rewrites only the sections you check. The other sections stay as they were on the page.',
            },
        },
        topicQuestion: 'Describe what the article should cover.',
        topicQuestionAnalyze: 'Briefly say what the page is about and what the edit should keep or strengthen.',
        topicLabel: 'Topic description (required)',
        wordCount: '{0} / {1} words',
        chipsLabel: 'Add to the description',
        chips: {
            beginnerGuide: 'Beginner guide',
            typeComparison: 'Comparison of types',
            costCalculation: 'Cost calculation',
            prosCons: 'Pros and cons',
            practicalTips: 'Practical tips',
            faq: 'Common questions',
        },
        chipExamples: {
            beginnerGuide: 'A beginner guide that explains the topic from the basics and walks the reader through it.',
            typeComparison: 'A comparison of types that sets the options side by side and helps with the choice.',
            costCalculation: 'A cost calculation with typical amounts and with what the price includes.',
            prosCons: 'Pros and cons in a clear overview, so the reader can compare the gains and the limits.',
            practicalTips: 'Practical tips the reader can use right away.',
            faq: 'Common questions and short answers about the topic.',
        },
        keyHint: 'Enter continues. Shift and Enter adds a new line.',
        localeQuestion: 'Choose the country and language.',
        localeHint: 'The article is written in the language you choose. The country and language are in the row below, and Change opens their list.',
        localeLabel: 'Country and language',
        localeRow: 'Country: {0} · Language: {1}',
        localeKeyHint: 'Enter continues.',
        summaryQuestion: 'Check this setup for AI Lucy. Change opens that step, and after you confirm you come back here.',
        summaryQuestionAnalyze: 'Check this setup for AI Lucy. Change opens that step, and after you confirm you come back here.',
        summaryStep: 'Check the setup',
        summaryFrameLabel: 'How do you want to write the article?',
        summaryFrameAnalyze: 'How do you want to improve the article?',
        generateNow: 'Generate now',
        generateNowLine: 'I will prepare the paragraphs from the keywords. Writing starts after you confirm it on the article page.',
        customizeFirst: 'Edit before generating',
        customizeFirstLine: 'You go through the keywords and edit them, then start the writing.',
        improveNow: 'Improve now',
        improveNowLine: 'I will prepare the selection on the article page. The edit starts only after you confirm it there.',
        customizeBeforeImprove: 'Edit the selection before improving',
        customizeBeforeImproveLine: 'You go through the keywords, then start the improvement on the article page.',
        keywordQuestion: 'Choose the main keyword.',
        keywordLead: 'Under the field, pick a similar phrase. The number beside it is the average monthly searches. The country and language are in the row above the phrases, and Change opens them again.',
        keywordWhat: 'A keyword is a phrase people type into search.',
        keywordLabel: 'Main keyword (required)',
        keywordEmpty: 'Write the main keyword. Then you can continue.',
        keywordKeyHint: 'Enter continues.',
        suggestionsLoading: 'Loading similar phrases',
        suggestionsLabel: 'Similar phrases',
        templateQuestion: 'Choose a structure template.',
        templateLead: 'Universal SEO is preselected. You can confirm it, or choose another card.',
        templateLabel: 'Structure template',
        templateKeyHint: 'Arrow keys move between the cards. Enter selects the card. Another Enter or Continue goes to the next step.',
        styleQuestion: 'Set the tone, audience, and depth.',
        styleLead: 'The values are already filled in. You can add secondary keywords when you want them.',
        styleLabel: 'Secondary keywords (optional)',
        styleKeyHint: 'Enter in the field adds a secondary keyword. Continue also adds text left in the field.',
        historyKeyword: 'Main keyword',
        historyTemplate: 'Template',
        historyStyle: 'Tone, audience, and depth',
        historySecondary: 'Secondary keywords',
        removeSecondary: 'Remove {0}',
        showEntered: 'Show the entered steps',
        stepsReady: 'Steps {0}–{1} are ready',
        enteredTitle: 'Entered steps',
        pickerTitle: 'Choose the country and language',
        asking: 'AI Lucy is preparing the question',
        emptyHint: 'Write the topic description. Then you can continue.',
        historyTopic: 'Topic description',
        change: 'Change',
        resumeTitle: 'Continue the draft you started?',
        resumeYes: 'Continue',
        resumeRestart: 'Start again',
        formLead: 'The topic description, country, and language stay with this setup. Fill in the next details in the steps under this line.',
    },

    keywords: {
        locationTitle: "Choose a target country and language to write the article in.",
        title: "Insert the main keyword of the article, for example: pie, apple pie or apple pie recipe.",
        subtitle: "You will be able to refine the keyword later in the keyword analysis.",
        label: "Keywords",
        manage: "Manage keywords",
        hint: "A keyword in SEO search engine optimization of texts is a term or phrase that people use when searching for information on the Internet. These keyword phrases are essential because search engines use them to index and rank search result pages..",
        location: "Country",
        language: "Language",
        keyword: "Keyword",

        confirm: "Confirm",

        edit: {
            locationTitle: "Chosen target country and language to write the article in.",
            title: "Here you can choose new main keyword",
            confirm: "Confirm"
        },

        toCount: 'Checked words count toward density by stem in a heading or sentence, not by exact wording.',
        occurrences: 'occurrences',
        countIntoDensity: 'count into density',
        wordAlreadySelected: 'This word was already entered!',
        alreadyInList: 'This word is already in the list. You can keep typing.',
        densityHint: 'Density and in-article highlighting use the keyword stem (barf also colors barfu), not an exact string match.',

        keywordSelection: 'Main keyword of your article is',
        keywordSelectionCaption: 'Within tens of seconds, AI Lucy will write an entire article based on the selected keywords. Fine-tune it, export it and publish it to the web.',
        allKeywords: 'Keyword analysis',
        reviewKeywordsHint: 'Select extra keywords for AI to use when improving the article by writing separate paragraphs. Keep the main keyword, or you can choose a different one.',
        editBrief: 'Edit article brief',
        hideBrief: 'Hide brief',
        applyAndEnhance: 'Improve the article with selected keywords',
        selectNewKeyword: 'Choose new keyword',
        closeAnalysis: 'Close keyword analysis',
        avgMonthlySearches: 'Average monthly searches',

        lucy: {
            forkTitle: 'How do you want to write the article?',
            forkTitleImprove: 'How do you want to improve the article?',
            forkLead: 'Both paths use the same analysis defaults — only whether you adjust the selection before writing differs.',
            forkLeadImprove: 'Both paths use the same analysis defaults — only whether you adjust keywords before improving differs.',
            generateNow: 'Generate now',
            improveNow: 'Improve now',
            improveNowLine: 'AI Lucy improves the article right away from the prepared selection — no need to expand keyword analysis.',
            customizeBeforeImprove: 'Edit selection before improving',
            customizeBeforeImproveLine: 'Opens keyword analysis: turn rows off and pick Own paragraph / Question / Weave into text.',
            generateNowLine: 'AI Lucy writes right away from the prepared selection — you do not need to expand anything.',
            customizeFirst: 'Edit before generating',
            customizeFirstLine: 'Expand the groups, turn rows off, and pick Own paragraph / Question / Weave into text.',
            fastSummaryTitle: 'AI Lucy will write the article from {0} selected paragraphs',
            fastSummaryDetail: 'The article topic (H1) does not use a slot. Citations and chat facts are outside the 20 limit — you can still expand groups and adjust.',
            paragraphsCounter: 'Paragraphs {0} / {1}',
            limitOk: '{0} paragraph slots left (H2 or FAQ). Weave into text and citations do not count.',
            limitFull: 'Limit of 20 is full — turn another row off or switch it to Weave into text first.',
            limitOver: 'Over the limit of 20: turn another paragraph off or switch it to Weave into text. Turning off always works.',
            limitEmpty: 'No paragraph is enabled — Generate stays visible but disabled.',
            limitBlocked: 'Limit of 20 paragraphs — turn another off or switch it to Weave into text.',
            alwaysInArticle: 'Always in article',
            slotH2: '1 paragraph (H2)',
            slotFaq: '1 paragraph (FAQ)',
            intent: {
                section: 'Own paragraph',
                faq: 'Question',
                weave: 'Weave into text',
            },
            tip: {
                mainTopic: 'Main article topic — always the H1, not counted toward 20.',
                turnOff: 'Turn off — always allowed, even above the limit of 20.',
                turnOn: 'Turn on for AI Lucy.',
                blockedAtLimit: 'Cannot add another paragraph slot — free a slot below 20 first.',
                intentSection: 'AI Lucy writes a standalone paragraph with an H2 subheading for this topic.',
                intentFaq: 'AI Lucy treats the phrase as a question-and-answer FAQ block.',
                intentWeave: 'AI Lucy weaves the phrase into existing parts without a new subheading — not counted toward 20.',
                limit20: 'At most 20 own sections (H2) and FAQ combined. Weave into text, citations, and chat facts do not count.',
                forkWaiting: 'Waiting for the analysis / headings',
                forkImmediate: 'AI Lucy writes now from the prepared pick: typically up to 6 own sections, up to 4 questions, 2–3 citations, and facts from chats you chose in analysis. No need to expand groups.',
                forkImmediateImprove: 'AI Lucy improves the article now from the prepared pick: typically up to 6 own sections, up to 4 questions, 2–3 citations, and chat facts. No need to expand keyword analysis.',
                forkCustomize: 'Expands the groups: turn rows off, add long-tail, and pick Own paragraph, Question, or Weave into text (max. 20 paragraphs).',
                forkCustomizeImprove: 'Opens keyword analysis: turn rows off, add long-tail, and pick Own paragraph, Question, or Weave into text (max. 20 paragraphs).',
                proAiLucy: 'Turns the topic on or off for writing. Turning off always works, even above 20 paragraphs.',
                h1: 'Main article heading — topic from analysis. Does not use a slot among the 20 paragraphs.',
                h2: 'Subheading of an own section. Each enabled Own paragraph uses one slot.',
                faq: 'Question-and-answer block in the article. Each enabled Question uses one slot.',
            },
            abbr: {
                TOP: 'Pages and keywords from the top organic Google results for the topic — same source as TOP content inspiration.',
                PAS: 'People also search suggestions on Google: related topics people often search after the same query.',
                PAA: 'Questions Google shows on the results page (People Also Ask).',
                LSI: 'Words and phrases related to the topic that belong in natural prose — entities and variants, not standalone questions.',
                Labs: 'Longer phrases from Keyword Labs (long-tail queries from analysis).',
                paa: 'Questions Google shows on the results page (People Also Ask).',
                pas: 'People also search suggestions on Google.',
                lsi: 'Words and phrases related to the topic that belong in natural prose.',
                ac: 'Google autocomplete phrases that are not questions.',
                autocomplete: 'Google autocomplete phrases that are not questions.',
                organicFaq: 'Questions from TOP pages in organic results.',
                mentions: 'Facts or citations from AI chat answers (AI Overview, ChatGPT, Gemini, Perplexity).',
                chat: 'Facts or citations from AI chat answers.',
            },
            writeDisabledEmpty: 'Select at least one own paragraph (H2) or question (FAQ) — max. 20 paragraphs.',
            writeDisabledOver: 'You have {0} paragraphs — turn another off or switch it to Weave into text.',
            generateNowNeedMore: '{0} paragraphs are selected. More are needed — turn on at least one own paragraph (H2) or question (FAQ).',
        },
        info: {
            items: {
                1: 'You can select a more precise keyword from the suggested keywords below in the "Select main keyword for optimization" column, or you can leave the original one.',
                2: 'You can select only one main keyword. Based on it, you will get inspiration to improve your texts.',
                3: 'As a main keyword, we recommend winning one that has an average number of searches per month of at least 400 and above.',
                4: 'In the "Choose for writing by AI Lucy" column, you can change the keywords on which the paragraphs of the article will be written. We recommend selecting "related" and "questions" keywords as much as possible.'
            },
            beforeButton: 'Have you chosen your main keyword for optimization? If so, press the button below.',
            selectedForAi: 'The number of keywords selected for text writing by AI Lucy:',
            beforeButtonNoData: 'People are not searching for the keyword you entered or only a few times a month and also the low monthly variation of the keyword will keep the article short. You now have two options to choose from.',
            tooManyKeywordsForAi: 'Choose at most 20 keywords for AI Lucy'
        },

        list: {
            header: {
                title: 'Keywords',
                keywordDifficulty: 'SEO difficulty',
                unknownKeywordDifficulty: 'Unknown SEO difficulty',
                knownKeywordDifficulty: 'The lower the value, the better your chances of being ranked in organic search results. The higher the value, the more attractive the keyword and the higher the competition.',
                averageSearches: 'Average number of searches per month',
                aiDemand: 'AI demand',
                aiDemandHint: 'Demand in AI search, not classic Google.',
                chooseKeyword: 'Choose main keyword for optimization',
                chooseKeywordHint: 'If you want, you can change the main keyword, based on which you will get inspires from the top 10 sites ranked in search engines.',
                chooseForAi: 'Choose for writing by AI Lucy',
                chooseForAiHint: 'If you want, you can change the keywords. Related words become H2 titles, questions become FAQ. AI Lucy writes one article, not a separate article per keyword.',
                forAiLucy: 'For AI Lucy'
            },
            variations: {
                title: 'variations',
                description: 'These are close variations of the main keyword. Replace the main keyword here and there, but beware of grammar - never use grammatically incorrect variants in the text.',
                useHint: 'LSI terms from AI answers have an LSI tag. Add to intro inserts them into the article and checks them for AI Lucy.'
            },
            questions: {
                title: 'questions',
                description: 'Questions related to the main keyword. Incorporate them into the article and answer them as practically as possible.',
                useHint: 'Add H2 / FAQ also checks the question for AI Lucy and inserts it into the editor. Removing FAQ when it is not an H2 unchecks it.'
            },
            longTail: {
                title: 'long tail',
                description: 'Less searched, but more accurate queries related to the main keyword. You can incorporate them into the article and analyze them in more detail.'
            },
            related: {
                title: 'related',
                description: 'Related keywords are secondary terms that help narrow the focus of the main keyword. These keywords allow target more specific phrases that branch off of the larger topic. So try not to deviate from the topic of the article.'
            },
            workspace: {
                related: 'Related topics',
                relatedSub: 'Related phrases and People also search',
                questions: 'Questions',
                questionsSub: 'Questions from search, AI chats and TOP page FAQs',
                lsi: 'Variants and LSI',
                lsiSub: 'Entities and close variants from the analysis',
                longTail: 'Long-tail',
                longTailSub: 'More specific, less searched queries',
                autocomplete: 'Google Autocomplete',
                autocompleteSub: 'Suggestions from Google Autocomplete. Empty groups stay hidden.',
                gap: 'Competitor topics',
                gapSub: 'Topics from gaps vs competing pages',
                colPhrase: 'Phrase · source',
                colQuestion: 'Question · source · PAA hint',
                colTerm: 'Term · source',
                colTopic: 'Topic · volume',
                colH2Faq: 'H2 · FAQ',
                colH2Intro: 'H2 · intro',
                analysisHint: 'keyword groups under one analysis expander',
                liveCount: '{0} cards',
                citeCount: '{0} sources',
            },
            peopleAlsoSearch: 'People also search',
            peopleAlsoSearchHint: 'Checking this selects the topic for AI Lucy like a related keyword. Add H2 inserts it into the editor.',
            autocomplete: 'Google Autocomplete',
            autocompleteHint: 'Google Autocomplete suggestions. Check them for AI Lucy; questions can also go into FAQ.',
            gapTopics: 'Competitor topics (volume)',
            gapTopicsHint: 'Keywords competing pages rank for, with monthly searches. Check to add as an H2 topic for AI Lucy.',
            serp: {
                featured_snippet: 'Google shows a featured snippet for this keyword. Informational; selection stays on the AI Lucy checkbox.',
                people_also_ask: 'Google shows People also ask for this keyword. Informational; selection stays on the AI Lucy checkbox.',
                ai_overview: 'Google shows AI Overview for this keyword. Informational; selection stays on the AI Lucy checkbox.',
            },
            empty: 'Unfortunately, there are no alternatives available for the chosen keyword for this category because people are not searching for them on the internet.',
            nothing: 'Unfortunately, there are no alternatives available for the chosen keyword for this category because people are not searching for them on the internet.',
            chooseNewKeyword: 'Change keyword',
            chooseNewKeywordHint: 'If this keyword is more concise, you can choose it as the new main keyword to generate inspiration for fine-tuning texts.'
        },

        generateInspiration: 'Generate SEO article',
        generateInspirationAnyway: 'Write article anyway',
        // Says exactly what CancelArticle gives back (src/service/articleCancelRefund.ts, #30943).
        deleteArticleAndRefundCredit: 'Cancel this article and refund the monthly plan credit',
        deleteArticleKeepExtraCredit: 'Cancel this article (the extra credit is not refunded)',
        deleteArticleKeepFreeAnalysis: 'Cancel this article (the free analysis is not refunded)',
        deleteArticleNoRefund: 'Cancel this article',
        notCreatedInThisBillingPeriod: 'Cannot refund credit, because the article was not created in this billing period.',

        aiPrompt: {
            title: 'AI text writing',
            letHer: 'Let AI Lucy write the article',
            description: 'Describe as best as possible everything that the article should contain. The more precise, the better.',
            promptExample: 'Example of description: Hints and tips on how to bake a delicious apple pie. Traditional, modern, and healthy apple pie recipes. See the Manual for more examples.',
        },

        simplify: {
            writeNow: 'Write article now',
            writeNowDescription: 'Uses your brief, template and tone. Paragraphs are written from the preselected keywords without extra tuning.',
            specify: 'Refine article content',
            specifyDescription: 'Adjust the focus keyword and the four keyword groups (analysis is already running). Then let AI write the article.',
        },

        analyze: {
            description: 'Enter the URL of the article whose SEO score you wish to improve.',
            urlInputHint: 'For example: https://www.yourweb.com/article-for-improvement',
            keywordSelectionCaption: {
                begin: 'After extracting the text from the URL, improve it according to',
                bold: 'SEO score factors',
                end: '. If the texts were not extracted, copy them manually.'
            },
            analyzeNow: 'Analyze the article now',
            analyzeNowDescription: 'I leave it to the application to handle the extraction without immediately detailing the content of paragraphs.',
            specifyDescription: 'I want to refine the content of paragraphs according to the keyword analysis before extraction (an extra minute of work).',
            aiPrompt: {
                description: 'Describe what the article contains and for whom it is intended.',
            }
        }
    },

    article: {
        getInspired: 'Inspiration from TOP content',
        editYours: 'Edit the text written by AI Lucy',
        words: 'words',
        numOfWords: '{0} words',
        details: "SEO parameters of the article",
        keyWordsCount: "Number of keywords in this inspiration text",

        list: 'Your articles',
        listMore: 'more',
        create: 'Create new article',
        view: 'View',
        createdAt: 'Created at',
        empty: 'No articles yet...',
        noTitle: "Article without a title",

        createDescription: "Generate new content for website or blog",

        analyze: {
            title: "Analyze article from URL",
            description: "Improve the content published on the URL",
            scrapeFail: {
                title: "Unsuccessful content extraction",
                description: "We're sorry, but SEOWRITEE was not able to extract any content from the URL provided. This might be due to the website's structure, restrictions on access, or the URL being incorrect. Please check the URL for any mistakes and try again.",
                creditRefunded: "Your credit has been refunded.",
                deleteArticle: {
                    text: "Delete article",
                    descriptionMonthly: "Your monthly plan credit will be refunded. You can try to create a new one or analyze another article.",
                    descriptionExtra: "Your extra credit will be refunded. You can try to create a new one or analyze another article.",
                    descriptionFree: "Your free analysis will be refunded. You can try to create a new one or analyze another article.",
                    descriptionNoRefund: "The article will be deleted. You can try to create a new one or analyze another article."
                },
                openEmpty: {
                    text: "Open empty article",
                    description: "You can write the article from scratch with AI Lucy."
                }
            },
            scrapePartial: {
                title: "Partial content extraction",
                description: "We're sorry, but SEOWRITEE was not able to extract all of the content from the URL provided. This might be due to the website's structure. Please check the URL for any mistakes and try again.",
                openPartial: {
                    text: "Open partial article",
                    description: "You can fill in the missing parts of the article manually or with AI Lucy."
                },
            }
        },

        contentExtraction: "Content extraction",

        save: 'Save article',
        saving: {
            title: 'Saving article...',
            content: 'Changes cannot be made while the article is being saved.'
        },
        saved: {
            title: 'Article successfully saved!'
        },
        saveHeld: {
            title: 'AI Lucy is still writing this article',
            content: 'The article was not saved, so finished text is not replaced by empty parts.',
        },
        saveHeldReview: {
            title: 'Review AI Lucy\'s proposals first',
            content: 'The article was not saved. Until you decide on every proposal (Accept or Keep the original), a section or FAQ question with text cannot be deleted or renamed.',
        },
        saveError: {
            title: 'Error while saving the article.',
            content: 'An error occurred while saving the article. Please check your internet connection and try again.'
        },

        updating: 'Updating article',
        updated: 'Article updated',

        generating: {
            title: 'Article generation...',
            content: 'AI Lucy writes one full article at the chosen length, including every selected FAQ, then fills H1–H6, FAQ and the snippet together. Target length is for the whole article — later sections are not dropped. Once the text is saved, you can edit immediately — there is no second text-polish pass.',
            localContent: 'AI Lucy is trying to write the whole article in this preview. If the text does not arrive, empty paragraphs open for editing.',
            continueWithoutAi: 'Open paragraphs without AI',
            localDoneTitle: 'Paragraphs are ready to edit',
            localDoneContent: 'AI Lucy did not load text in this preview. You can write by hand. On the DEV site AI Lucy writes for real.',
        },
        generated: {
            title: 'Article successfully generated!',
        },
        generateError: {
            title: 'Error while generating the article.',
            content: 'Some texts could not be generated. You can fill them in manually.',
        },

        enhancing: {
            title: 'Enhancing the article...',
            content: 'Changes cannot be made while the article is being enhanced.',
            localContent: 'AI Lucy is trying to enhance the article in this preview. If the text does not arrive, we unlock the paragraphs for editing.',
            continueWithoutAi: 'Continue without AI',
            localDoneTitle: 'Editing is unlocked',
            localDoneContent: 'AI Lucy did not load new text in this preview. You can edit the scraped article and empty paragraphs by hand. On the DEV site AI Lucy writes for real.',
        },
        enhanced: {
            title: 'Article successfully enhanced!',
        },
        blockProposals: {
            title: 'AI Lucy prepared proposals for the sections',
            lead: 'The original text stays until you accept a proposal.',
            original: 'Original text',
            proposal: 'Proposal',
            accept: 'Accept',
            keep: 'Keep the original',
            newSection: 'New section',
            accepted: 'Accepted',
            kept: 'Kept',
            retry: 'Retry',
            failedMissing: 'AI Lucy left numbers, years, or amounts out of the proposal. You can try this section again.',
            failedInvented: 'AI Lucy added a number or a year that is not on the page. You can try this section again.',
            failedChangedNumberMeaning: 'The meaning of a number changed.',
            failedInstructionLeak: 'AI Lucy copied validation instructions into the proposal instead of article text. You can try this section again.',
            failedUnusable: 'AI Lucy did not prepare this section. You can try again.',
            failedEmptyAnswer: 'AI Lucy returned no text for this section. You can try again.',
            tableKept: 'We are keeping the table as it is.',
            figuresKept: 'We are keeping the figures as they are in the source.',
            warningMissing: 'AI Lucy left a few figures from the original out of the proposal.',
            readyTitle: 'AI Lucy has proposals for the sections',
            readyContent: 'The original text stays until you accept a proposal.',
            settled: 'Done. Every proposal is settled.',
        },
        enhanceError: {
            title: 'Error while enhancing the article.',
            content: 'An error occurred while enhancing the article. Please check your internet connection and try again.',
        },
        partsFailed: {
            title: 'AI Lucy did not finish enhancing the article',
            content: 'A part failed, or the time limit passed before every part was done. You can run generation again.',
            retry: 'Retry',
        },
        wholeFailed: {
            title: 'AI Lucy did not finish the article',
            content: 'Some parts of the article could not be generated. Generate them again, or fill them in by hand.',
            retry: 'Retry',
        },
        manualEnhance: {
            title: 'Article content enhancement',
            titleReady: 'The article is ready to enhance',
            description: 'AI Lucy uses the words from the brief (H2 and FAQ). Open keyword analysis only if you want to add more.',
            descriptionReady: 'The selected keywords are ready. AI Lucy will now add further relevant parts to the article.',
            danger: 'The enhancement adds additional article parts. This step is irreversible.',
            enhance: 'Enhance article',
            enhanceNow: 'Enhance article now',
            loadingPage: 'AI Lucy is loading the page…',
            tooltip: {
                tooManyKeywords: 'To enhance the article, select a maximum of 20 keywords',
                noKeywords: 'To enhance the article, select at least one keyword',
            }
        },

        polishing: {
            title: 'Refining the article...',
            content: 'Changes cannot be made while the article is being refined.'
        },
        polished: {
            title: 'Article successfully refined!',
        },
        polishError: {
            title: 'Error while refining the article.',
            content: 'An error occurred while refining the article. Please check your internet connection and try again.',
        },
        manualPolish: {
            title: 'Refine article content',
            description: 'This step is no longer needed. AI Lucy writes the whole article at once and splits it into H headings. A second text-polish pass after generate does not run.',
            danger: 'Refinement would overwrite the original article. This step does not run after a whole-article generate.',
            polish: 'Refine article',
        },

        loadingError: {
            title: 'Error while loading article.',
            content: 'An error occurred while the article was loading. Please check your internet connection and try again.',
        },

        exportError: {
            docx: {
                title: 'Error while creating DOCX export of article.',
            },
            clipboard: {
                title: 'Error while copying article to clipboard.',
            },
            basic: {
                title: 'Error while exporting article.',
            }
        },

        overview: {
            selectedKeyword: {
                title: 'Chosen keyword',
                description: 'The main keyword, or topic, about which you are writing an article. We will help you get inspiration for its detailed description and explanation to readers, ie the target group.'
            },
            idealURL: {
                title: 'Ideal URL of article',
                description: 'This is what an article URL, landing page, or any part of a website should look like in SEO terms. The shorter and more relevant the keyword, the better. The variant with www or without depends on how you have the website domain set up.'
            },
            ALTDescription: {
                title: 'ALT image description',
                description: 'Be sure to describe the images with the main keyword and its variants the ALT attribute of the image. You can usually find this option in the web content administration.'
            },
            recommendedLength: {
                title: 'Minimum recommended article length',
                description: 'If you want to be in the top positions in organic search, your article must have the correct number of words. We have calculated the minimum number of the best articles on the Internet and I will keep an eye on your word count.'
            },
            recommendedDensity: {
                title: 'Recommended keyword density',
                description: 'The main keyword should appear naturally — in grammatically correct form, not as a stuffed string. We measure density from the word stem.'
            },
            length: "Length",
            density: "Density of chosen words",
            moreDetails: "More details",
            lessDetails: "Less details",
            recommendedKeywordCount: 'for article length of {0} words it is {1} keywords'
        },

        label: {
            metaTitle: 'meta title',
            metaDescription: 'meta description',
            h1h: 'H1 ' + heading,
            h1p: 'H1 ' + paragraph,
            h2h: 'H2 ' + heading,
            h2p: 'H2 ' + paragraph,
            h3h: 'H3 ' + heading,
            h3p: 'H3 ' + paragraph,
            h4h: 'H4 ' + heading,
            h4p: 'H4 ' + paragraph,
            h5h: 'H5 ' + heading,
            h5p: 'H5 ' + paragraph,
            h6h: 'H6 ' + heading,
            h6p: 'H6 ' + paragraph,
            images: 'images',
        },

        eat: {
            chip: 'Author & E-E-A-T',
            title: 'Author, date and trust',
            description: 'Google and AI systems treat a named author, update date and expert bio as an E-E-A-T signal. We load them from the analyzed URL; you can edit them.',
            loading: 'Loading author and date from the original page…',
            empty: 'Add an author, date and a short bio. For a URL article we load them from the source when the page publishes them.',
            author: 'Author',
            authorPlaceholder: 'e.g. Carlos Silva',
            role: 'Author role',
            rolePlaceholder: 'e.g. Content Production Expert',
            contributors: 'Contributors',
            contributorsPlaceholder: 'Other editors or reviewers, comma-separated',
            published: 'Published',
            updated: 'Updated',
            datePlaceholder: 'e.g. June 3, 2026',
            readMinutes: 'Read time (min)',
            minRead: 'min read',
            bio: 'Author bio',
            bioPlaceholder: 'Who wrote the article, their experience, and why they are qualified on the topic.',
        },

        inspirationFor: {
            title: '{0} inspiration',
            metaTitle: 'The text that will appear in the search results. Be inspired by the best headlines and write even better, more attractive and concise.',
            metaDescription: 'The text that will appear in the search results. Be inspired by the best descriptions and write even better, more attractive and concise.',
            h: 'Get inspired by the headlines of the best articles on the Internet and write even more attractive and concise.',
            p: 'Get inspired by the paragraphs of the best articles on the Internet and write even more attractive and concise.'
        },
        inspirationDetail: 'Open detail',
        noInspiration: 'None of the inspiration sites used this part of the page, but you can fill it out.',
        hideInspiration: 'Hide this inspiration',
        hideAndMarkUnrelevant: 'Hide and mark as irrelevant',
        copyInspiration: 'Copy to overwrite',
        copiedToClipboard: 'Copied to clipboard!',

        placeholder: {
            metaTitle: 'Write the meta title here',
            metaDescription: 'Write the meta description here',
            heading: 'Write the heading here',
            paragraph: 'Write the paragraph here',
            question: 'Write the question here',
            answer: 'Write the answer here',
        },

        writeBetter: {
            meta: 'Edit the {0} to be more descriptive than the inspiration',
            heading: 'Edit the {0} to be more descriptive than the inspiration',
            headingBrief: '{0} heading and paragraph',
            paragraph: 'Edit the paragraph to make it more interesting than the inspiration',
            placeholder: {
                meta: 'Write your own {0}, which will be more concise than those stated on the left',
                heading: 'Write {0} in here which will be corresponding to the purpose of your article',
                paragraph: 'Write paragraph in here which will be related to the heading above and describe the topic in detail'
            }
        },

        contentList: {
            title: 'Content list',
            hint: 'Will be generated automatically during writing of the article.',
            dragHint: 'Drag to reorder headings',
            emptyHeading: '(empty heading)',
            description: 'The list of article content is important for the quick orientation of the reader in the text. It is created automatically as you type headings.',
            empty: 'empty',
            showAll: 'Show all ({count})',
            showLess: 'Show less',
        },

        questions: {
            title: 'Edit the answer or write your own',
            question: 'Question',
            answer: 'Answer',
            remove: 'Delete question'
        },

        answers: {
            title: "Answers to questions",
            description: "Answering frequently asked questions closely related to the keyword will increase the quality of the article optimization as well as the content value for your readers."
        },

        tips: {
            label: 'Tips',
            metaTitle: 'In addition to the main keyword, use a number, the question how, why or where, a list, an attractive price, etc. in the title. Use the maximum recommended number of characters.',
            metaDescription: 'Using the main keyword and other information, describe the content of the article as attractively as possible by listing the content, unique advantages and benefits. Make the most of the recommended number of characters.',
            h1h: 'Use the keyword in the title and describe the main message of the article. Use the H1 heading only once in an article',
            h1p: 'Use the main keyword meaningfully at the beginning of the paragraph and summarize the content of the whole article in it so that you entice the reader to read it in its entirety.',
            h2h: 'Use another keyword variation or question keyword in this and other headings. You can reuse headings H2 through H6 in this article.'
        },

        extendWithAi: {
            fillPrompt: 'Fill the instruction for AI Lucy',
            generating: 'AI Lucy is writing the next part…',
            heading: {
                run: 'Generate paragraph for this heading',
            },
            paragraph: {
                toggle: 'Extend paragraph with AI Lucy',
                prompt: 'Give our AI Lucy what to write about next for this paragraph.',
                run: 'Generate next part',
                use: 'Add to paragraph',
            },
            question: {
                run: 'Generate answer for this question',
            },
            answer: {
                toggle: 'Extend answer with AI Lucy',
                prompt: 'Give our AI Lucy what to write about next for this questions answer.',
                run: 'Generate next part',
                use: 'Add to answer',
            },
            discard: {
                tooltip: 'Discard',
                title: 'Are you sure to discard the following extension?',
                confirm: 'Discard'
            },
        },

        addSubpart: 'Insert {0} with paragraph',
        addAnotherSubpart: 'Insert another {0} with paragraph',
        dragBlock: 'Drag to reorder',
        removeSubpart: {
            tooltip: 'Delete this heading and paragraph',
            title: 'Are you sure to delete the following {0} with its paragraph?',
            confirm: 'Delete'
        },
        addQuestion: 'Add another question',
        faqIncompletePruned: {
            title: 'Empty FAQ rows are skipped',
            content: 'A question without an answer (or the other way around) is omitted from preview and export. Fill it in or delete it before you generate.',
        },
        removeQuestion: {
            tooltip: 'Delete this question',
            title: 'Are you sure to delete the following question with its answer?',
            confirm: 'Delete',
        },

        images: {
            title: 'Article images',
            description: 'List images used in the article. Fill out the ALT attributes of the images so SEOWRITEE can check it for you.',
            add: 'Add image',
            remove: 'Delete image',
            showAll: 'Show all ({count})',
            showLess: 'Show less',
            alt: {
                header: 'ALT attribute',
                placeholder: 'Write the description of the image here',
            },
            url: {
                header: 'URL of externally hosted image',
                placeholder: 'https://www.yourweb.com/image.jpg',
            }
        },

        SERPPreview: {
            title: 'See, how your SERP preview will look like',
            description: 'This is exactly how people will see your site\'s page in organic search results. Make sure it is attractive and entices people to click. This will affect traffic to your site. SERP means Search Engine Results Page.'
        },
        urlSuggestion: {
            ideal: 'Suggested ideal URL',
            yours: 'Your URL',
            redirectNote: 'If you change the URL, set a permanent 301 redirect.',
        },
        preview: 'Page preview',
        previewTooltip: 'See the article as a finished page: reader view on desktop and mobile, HTML with microdata, Schema.org JSON-LD, CMS markup, Open Graph and a check of what the output covers.',
        previewDialog: {
            title: 'Full article preview & HTML code',
            badge: 'Reader & Microdata',
            subtitle: 'A visual preview of the formatted article, or a side-by-side view with HTML and Schema.org microdata.',
            expand: 'Expand to full screen',
            reader: 'Reader preview',
            split: 'Side by side (Preview + HTML)',
            htmlMicrodata: 'HTML code & microdata',
            desktop: 'Desktop',
            mobile: 'Mobile',
            reading: 'Reading',
            copyHtml: 'Copy HTML',
            markdown: 'Markdown',
            print: 'Print',
            printBlocked: 'Print cannot start in this window. On your computer in Chrome, Edge or Safari the system Print dialog opens with the article.',
            download: 'Download',
            copyCode: 'Copy code',
            schemaValidator: 'Schema.org validator',
            searchCode: 'Search in code (e.g. itemprop, ld+json)…',
            lines: '{0} lines',
            bytes: '{0} bytes',
            untitled: 'Untitled',
            updatedNow: 'Updated just now',
            readTime: '{0} min read',
            words: '{0} words',
            microdataLive: 'Automatic microdata & Schema.org JSON-LD checks are on',
            close: 'Close preview',
            tabs: {
                full: 'Complete HTML (with microdata)',
                schema: 'Schema JSON-LD',
                cms: 'HTML for CMS (body)',
                audit: 'Microdata & schema audit',
            },
            kind: {
                full: 'HTML5 + microdata',
                schema: 'JSON-LD',
                cms: 'HTML body',
            },
            audit: {
                schema: 'JSON-LD structured data is in the code',
                blogPosting: 'BlogPosting type is present',
                headline: 'Headline / meta title is filled in',
                description: 'Description is filled in',
                canonical: 'Canonical URL is ready',
                openGraph: 'Open Graph tags are in <head>',
                h1: 'The article has an H1',
                faq: 'FAQ is complete, or the article has no FAQ',
                images: 'Images have ALT text, or the article has no images yet',
                lang: 'The HTML language is set',
            }
        },

        currentLength: {
            title: 'Current length of your article',
            description: 'We count the current number of words for you and at the same time compare it with their ideal number.'
        },
        currentDensity: {
            title: 'Current density of chosen words',
            description: 'We calculate density from the keyword stem in headings and sentences, not from an exact string match, and watch the ideal number of hits.'
        },
        export: {
            title: 'Article export',
            description: 'We strongly recommend to publish only your original text. When you finish the final version of your article, make sure that all of its contents are original. If not, rewrite them using your own words.'
        },

        density: {
            low: 'Add some more keywords',
            ok: 'Current number of keywords is alright',
            high: 'You are repeating the keywords too often, remove some of them'
        },

        download: {
            title: 'Download the content of your optimized article and put it on your website',
            formats: {
                [DownloadType.DOCX]: 'docx',
                [DownloadType.HTML]: 'html',
                [DownloadType.CLIPBOARD]: 'Copy to Clipboard',
                [DownloadType.RTF]: 'rtf'
            }
        },

        generateNewInspiration: 'Generate new article',

        recommendation: {
            title: 'More tips how to optimize your web and strengthen your ranking with search engines',
            description: 'Here are some more tips and tricks to help your article rank high in organic search results and get free web traffic.',
            items: {
                1: 'Add interesting information, ideas and inspiration from TOP content to the texts written by AI Lucy.',
                2: 'Insert images, videos, graphs etc. into the article and insert relevant keywords into the ALT description.',
                3: 'Do not use keywords too often, keep the occurence of them between the recommended value.',
                4: 'Never copy inspirations into your article, because search engines ignore duplicated content.',
                5: 'Your article should be at least that long, ideally longer, than article on the first position.',
                6: 'Insert links to sources related to the topic, which do not compete with your company, into your article.',
                7: 'Insert links to other related articles on your website.',
                8: 'Make sure to update information in the article, because search engines prefer up to date information.',
                9: 'Get good backlinks for your article from trustworthy and non competing websites.',
                10: 'Share the article on social media and reach out to other authors writing about the same topic.',
                11: 'Create video, podcast or presentation from the article and share them on the internet appropriately.',
                12: 'If you are looking for professional advice with content and technical SEO, contact us directly at https://seomaker.cz/en/home/'
            }
        },

        openAi: {
            loading: 'AI Lucy is preparing the text…',
        }
    },

    seoScore: {
        seo: 'SEO',
        score: 'SEO score',
        showDetails: 'Show details',
        legendRed: 'Critical',
        legendYellow: 'Warnings',
        legendGreen: 'Passed',
        emptyGroup: 'No SEO factors in this color',
        schemaMarkup: {
            label: 'Schema markup & structured data',
            description: 'Add JSON-LD (BlogPosting, FAQPage) to the article code for Google and AI Overviews.',
            green: 'JSON-LD is in the article',
            red: 'JSON-LD is missing',
        },
        aiVisibility: {
            label: 'AI visibility estimate',
            description: 'How likely the article is to be used by Google AI Overviews, Gemini, ChatGPT, Perplexity and Copilot. Currently {0}%.',
            green: 'Good chance of being cited in AI answers ({0}%)',
            yellow: 'Partial AI visibility ({0}%) — add FAQ, facts or schema',
            red: 'Low AI visibility ({0}%) — add conversational FAQ and structured data',
        },
        eeatScore: {
            label: 'E-E-A-T score',
            description: 'Experience, Expertise, Authoritativeness, Trustworthiness — Google’s four content-quality pillars. Score {0} / 100.',
            green: 'Strong E-E-A-T signals ({0} / 100)',
            yellow: 'E-E-A-T can be stronger ({0} / 100) — add experience, citations and trust cues',
            red: 'Weak E-E-A-T ({0} / 100) — missing first-hand experience, depth or trustworthy sources',
        },
        eatAuthor: {
            label: 'Named article author',
            description: 'The article names an author, which Google reads as an E-E-A-T Experience and Authoritativeness signal.',
            green: 'Author is filled in',
            red: 'Author is missing',
        },
        eatDate: {
            label: 'Publish or update date',
            description: 'A visible date shows the content is maintained. For a URL article we take the date from the source.',
            green: 'Date is filled in',
            red: 'Date is missing',
        },
        eatBio: {
            label: 'Author expertise bio',
            description: 'A short bio (experience, role, competence) strengthens Expertise. Aim for at least two sentences.',
            green: 'Bio is filled in',
            yellow: 'Bio is missing or too short',
        },
        faqPresent: {
            label: 'Article FAQ section',
            description: 'Counts question-and-answer pairs in the FAQ editor and question-style headings in the article body. Q&A found: {0}',
            green: 'At least one question and answer',
            red: 'FAQ is missing',
        },
        keywordVariants: {
            label: 'Keyword variants',
            description: 'The text of the article should contain multiple variations of the main keyword. You can find them in the keyword analysis: Keywords - related. Entered keyword variants: {0}',
            green: 'Two or more ',
            yellow: 'One',
            red: 'None',
        },
        keywordInSlug: {
            label: 'URL slug includes keyword',
            description: 'The URL is enough when it contains the keyword words — in any order, with other words in between, with or without a trailing slash. Suggested ideal URL: "{1}".',
            green: 'The URL path includes the focus keyword words.',
            red: 'The URL path does not yet include the focus keyword "{0}".',
        },
        imgAltIncludesKeyword: {
            label: 'Image ALT includes keyword',
            description: 'Make sure that the ALT, which is the alternate text of the image, contains the main keyword. Image ALT includes "{1}"',
            green: 'Used',
            red: 'Missing'
        },
        titleIncludesKeyword: {
            label: 'Meta title includes keyword',
            description: 'The meta title is the most SEO relevant HTML tag and must contain, ideally right at the beginning, the main keyword. Meta title includes "{1}"',
            green: 'Includes',
            red: 'Does not include'
        },
        titleLength: {
            label: 'Meta title length',
            description: 'Meta title length is {0} characters',
            green: 'Less than {1} characters',
            red: 'More than {1} characters'
        },
        descriptionIncludesKeyword: {
            label: 'Meta description includes keyword',
            description: 'The meta description tag informs site visitors and search engines what your article is about. Make sure it contains the main keyword. Meta description includes "{1}"',
            green: 'Includes',
            red: 'Does not include'
        },
        descriptionLength: {
            label: 'Meta description length',
            description: 'Meta description length is {0} characters',
            green: 'Less than {1} characters',
            red: 'More than {1} characters'
        },
        keywordDensity: {
            label: 'Main keyword density',
            description: 'The main keyword should occur naturally in grammatically correct form. Do not overdo the amount. Density is measured from the stem, not exact wording. Main keyword density is {0}%',
            green: 'Within recommended range {1} - {2}%',
            yellow: 'Low density (< {1}%)',
            red: 'High density (> {2}%)'
        },
        serpIsComplete: {
            label: 'SERP is completely written',
            description: 'Make sure the Meta title and Meta description are filled in the article code. Meta title and meta description are filled',
            green: 'Filled',
            red: 'Not filled',
        },
        avgWordCountOfTopTen: {
            label: 'Longer than average top ten articles',
            description: 'Current length of the article is {0} words',
            green: 'More than {1} words',
            red: 'Less than {1} words',
        },
        longestWordCountOfTopTen: {
            label: 'Longer than longest top ten article',
            description: 'This is an optional recommendation, not a requirement. A longer article can help with top positions, but only stretch it when that still makes sense. Current length of the article is {0} words',
            green: 'More than {1} words',
            yellow: 'Fewer than {1} words — optional recommendation',
            red: 'Fewer than {1} words',
        },
        keywordInIntroduction: {
            label: 'Keyword in first paragraph',
            description: '"{1} in first paragraph',
            green: 'Used',
            red: 'Missing'
        },
        keywordInH1: {
            label: 'Keyword in H1 heading',
            description: '"{1}" in H1 heading',
            green: 'Used',
            red: 'Missing'
        },
        keywordInH2: {
            label: 'Keyword in H2 heading',
            description: '"{1}" in H2 heading',
            green: 'Used',
            red: 'Missing'
        },
        keywordInH3: {
            label: 'Keyword in H3 heading',
            description: '"{1}" in H3 heading',
            green: 'Used',
            red: 'Missing'
        },
        relatedKeywords: {
            label: 'Additional relevant keywords',
            description: 'Also incorporate other related keywords found in the keyword analysis into the headings and paragraphs of the article. {0} additional relevant keywords used in the article',
            green: 'At least half used',
            red: 'Less than half used'
        },
        inboundLinks: {
            label: 'Internal links',
            description: 'Insert a few internal links to your articles on similar topics or explaining the concepts used in them. Links to your own website: {0}',
            green: 'At least one link',
            red: 'No links'
        },
        outboundLinks: {
            label: 'External links',
            description: 'Make sure that the text of the article contains several links to sites (that are not your competitors) with interesting and quality content. Links to other websites: {0}',
            green: 'At least one link',
            red: 'No links'
        },
        inspirationFromTopTen: {
            label: 'Inspiration from top ten articles.',
            description: 'Enrich your article with information from the best optimized web sites. Simply click on "Inspiration from Top Content" under each heading or paragraph.',
            green: 'Inspiration from top ten articles.',
            red: 'Without inspiration'
        },
        subHeadingDistribution: {
            label: 'Subheading distribution',
            description: 'To make it easier to read the content of an article, it is important to use subheadings to separate the text of long paragraphs. Subheading filled for {0} out of {1} parts',
            green: 'All filled',
            red: 'Some missing'
        },
        paragraphLength: {
            label: 'Paragraph length',
            description: 'Short paragraphs are important to make the content of the article easier to read. Short (<150 words) paragraph ratio is {0}',
            green: 'Most paragraphs are short',
            yellow: 'At least half of the paragraphs are short',
            red: 'Paragraphs are long'
        },
        sentenceLength: {
            label: 'Average sentence length',
            description: 'Short sentences make it easier and faster to read and understand the content of the article. Average sentence length is {0} words',
            green: 'Less than {1} words',
            yellow: 'Less than {2} words',
            red: 'More than {2} words',
        },
        detail: {
            title: 'SEOWRITEE SEO analysis factors',
            subtitle: 'Improve writes only safe mechanical fixes. Text factors open the editor — template hacks are not inserted.',
            openPage: 'Improve SEO score',
            needsOptimization: 'Needs optimization',
            canImprove: 'Can be improved',
            lookingGood: 'Looking good',
            filterAll: 'All',
            filterGreen: 'Passed',
            filterYellow: 'Warnings',
            filterRed: 'Critical',
            words: 'Words: {0}',
            readTime: 'Time: ~{0} min',
            categoriesLabel: 'Factor categories',
            categories: {
                all: 'All factors',
                ai: 'AI visibility',
                eeat: 'E-E-A-T',
                schema: 'Schema markup & AI',
                headings: 'H1 & headings',
                serp: 'SERP snippet & meta',
                keywords: 'Keywords & LSI',
                content: 'Content & FAQ',
                readability: 'Readability & structure',
                images: 'Images & alt',
                links: 'Links & intent',
            },
            geoTitle: 'SEO & AI (GEO) optimization',
            geoBody: 'The 1–100% score covers Schema.org JSON-LD, AI visibility (GEO), E-E-A-T, keyword density, and readability.',
            improve: 'Improve',
            ok: 'OK',
            improveAll: 'Improve all ({0})',
            close: 'Close',
            celebrate: 'Celebrate score',
            celebrateToast: 'Great SEO score — the article is ready to publish.',
            applied: 'The fix was written into the article',
            appliedAll: 'Available fixes were written into the article',
            editorHint: 'Edit this factor in the article editor',
            lucyHint: 'Open the editor — AI Lucy should improve this factor in the text; no template is inserted',
            emptyTitle: 'Open an article first',
            emptyBody: 'The detailed SEO score is calculated from the current article. Open an article, then come here from the left menu or the top bar.',
            openArticles: 'Go to articles',
            noFactors: 'Nothing matches this filter.',
            introSentence: '{0} matters right from the opening paragraph.',
            faqQuestion: 'What is {0}?',
            faqAnswer: '{0} is the main topic of this article. Add a concrete, useful answer here.',
            internalLinkLabel: 'related article',
            ai: {
                summary: 'Estimated AI visibility is {0}%. For “{1}”, conversational FAQ, JSON-LD, concrete numbers and direct answers matter — for new drafts and URL analysis alike.',
                platformsTitle: 'Estimated visibility by platform',
                factorsTitle: 'Key factors for visibility in AI chats (generative search engines)',
                modeWrite: 'Measured from the text you are writing: FAQ, schema, facts, links and a direct answer in the intro.',
                modeAnalyze: 'Measured from content scraped from the URL: the same on-page signals plus HTTPS and freshness.',
                directAnswer: 'Direct answer: {0} is the main topic of this article, and the reader should understand it in the opening.',
                factSentence: 'In numbers: {0} is worth backing with 10+ comparisons and verified figures.',
                platforms: {
                    googleAio: 'AI Overviews',
                    chatgpt: 'ChatGPT',
                    perplexity: 'Perplexity',
                    copilot: 'Copilot',
                },
                factors: {
                    faq: {
                        title: 'Questions and answers (FAQ block)',
                        ok: 'The article has at least one question with an answer — in the FAQ section, or as a question-style heading. AI chats cite that Q&A block.',
                        fail: 'There is no question + answer pair. Add an FAQ section. This is the Q&A structure AI chats quote, not whether the intro matches the keyword.',
                    },
                    schema: {
                        title: 'Schema.org structured data',
                        ok: 'JSON-LD is in the article and helps AI extract meaning.',
                        fail: 'Without FAQPage / BlogPosting schema, AI systems are less likely to cite the page.',
                    },
                    facts: {
                        title: 'Concrete factual content',
                        ok: 'The text includes numbers, years or comparisons that AI likes to quote.',
                        fail: 'Add concrete numbers, comparisons or definitions for {0}.',
                    },
                    outbound: {
                        title: 'Authoritative citations',
                        ok: 'The article cites an external source, which increases trust for AI.',
                        fail: 'Add a link to a trustworthy source — Perplexity and Copilot rely on citations.',
                    },
                    freshness: {
                        title: 'Content freshness',
                        ok: 'The text looks current (this year, or a recently saved article).',
                        fail: 'Update facts and dates — AI models prefer newer sources.',
                    },
                    answers: {
                        title: 'Direct answer to the search query',
                        ok: 'The H1 or intro covers the keyword, or a question in the article targets it — AI can cite the first answer to “{0}”.',
                        fail: 'The intro does not yet answer the query “{0}”. Put the topic in the H1 or first sentence. That is a different signal from an FAQ block at the end.',
                    },
                }
            },
            eeat: {
                intro: 'What is E-E-A-T? Experience, Expertise, Authoritativeness, Trustworthiness — Google’s four content-quality pillars. Especially critical for YMYL topics.',
                signalsTitle: 'Detailed E-E-A-T signals',
                actionsTitle: 'Actions to take now',
                experienceHeading: 'Hands-on experience',
                experienceBody: 'In practice we verified {0} on concrete cases: we recorded the steps, limits and outcome so the reader sees first-hand experience, not only a generic description.',
                modeWrite: 'For a new article we score on-page signals (experience in the text, depth, citations, schema). Site signals such as HTTPS count once you add a URL.',
                modeAnalyze: 'For URL analysis we also count HTTPS and the age of the scraped content, not only what is in the editor.',
                pillars: {
                    experience: {name: 'Experience', hint: 'First-hand experience'},
                    expertise: {name: 'Expertise', hint: 'Content expertise'},
                    authoritativeness: {name: 'Authoritativeness', hint: 'Source authority'},
                    trustworthiness: {name: 'Trustworthiness', hint: 'Trust'},
                },
                signals: {
                    reviews: {
                        title: 'Real-world proof',
                        ok: 'The text includes experience, a review or a test — a first-hand signal.',
                        fail: 'Add a review, a test, or “we verified this in practice” for {0}.',
                    },
                    author: {
                        title: 'Attributed authorship',
                        ok: 'The article names an author in the Author & E-E-A-T section.',
                        fail: 'Add an author name in the section before the snippet — Google values identifiable experts.',
                    },
                    authorBio: {
                        title: 'Author expertise bio',
                        ok: 'The author has a bio with role or experience, so Expertise is readable.',
                        fail: 'Add a short author bio — who they are and why they are qualified.',
                    },
                    freshDate: {
                        title: 'Visible content date',
                        ok: 'The article has a publish or update date.',
                        fail: 'Add an update date so the content looks maintained.',
                    },
                    specialization: {
                        title: 'Topical specialization',
                        ok: 'The article has subheadings and enough length to look specialized.',
                        fail: 'Expand the H2 structure and length so expertise on {0} is obvious.',
                    },
                    depth: {
                        title: 'Depth of expertise',
                        ok: 'Length and subheadings are enough for expert coverage.',
                        fail: 'Add deeper sections, comparisons or a process — thin content fails E-E-A-T.',
                    },
                    mentions: {
                        title: 'Links and mentions',
                        ok: 'The article has internal or external links that support authority.',
                        fail: 'Add a citation or an internal link — authority is hard to prove without mentions.',
                    },
                    citations: {
                        title: 'Citations from topical sources',
                        ok: 'The article includes an external citation backing a claim.',
                        fail: 'Cite a trustworthy source for {0}.',
                    },
                    https: {
                        title: 'HTTPS and technical trust',
                        ok: 'The URL is HTTPS, or this is a new draft without a public URL yet.',
                        fail: 'Publish on HTTPS. URL analysis without HTTPS lowers trustworthiness.',
                    },
                    transparency: {
                        title: 'Transparency and trust cues',
                        ok: 'The text or schema includes trust cues (source, terms, contact traces).',
                        fail: 'Add a source, terms or schema — Trustworthiness stays weak without them.',
                    },
                }
            },
            status: {
                green: 'Passed',
                yellow: 'Warning',
                red: 'Critical issue',
            },
            tips: {
                aiVisibility: 'Add a citable passage, an FAQ from the content, and schema. A template sentence is not inserted into the intro.',
                eeatScore: 'For a new article, add practice from the briefing. For a URL article, fill in the author, date and bio in the section before the snippet.',
                eatAuthor: 'Add the author name. For a URL article we load it from the source.',
                eatDate: 'Add a publish or update date.',
                eatBio: 'Write two sentences about the author’s experience — that strengthens Expertise.',
                schemaMarkup: 'When improving, JSON-LD is inserted into the code from the article content (Article and FAQ, only when FAQ exists).',
                faqPresent: 'Add at least one question with an answer — in the FAQ section, or as a question-style heading in the body.',
                keywordVariants: 'Add at least 2–3 keyword variants from the keyword suggestions.',
                keywordInSlug: 'The URL should contain the keyword words. Order, extra words and a trailing slash do not matter.',
                imgAltIncludesKeyword: 'Add an image whose ALT text includes the main keyword.',
                titleIncludesKeyword: 'Place the main keyword at the start of the meta title.',
                titleLength: 'Shorten the meta title to the recommended length so it is not cut in the SERP.',
                descriptionIncludesKeyword: 'Include the main keyword in the meta description.',
                descriptionLength: 'Shorten the meta description to the recommended length.',
                keywordDensity: 'Adjust keyword usage so density stays in the recommended range.',
                serpIsComplete: 'Fill in both meta title and meta description so the SERP snippet is complete.',
                avgWordCountOfTopTen: 'Write until the article matches the average length of the top 10 results.',
                longestWordCountOfTopTen: 'Writing longer than the longest top 10 article is an optional recommendation. Follow it only when a longer article still makes sense.',
                keywordInIntroduction: 'Use the main keyword in the first paragraph.',
                keywordInH1: 'Put the main keyword in the H1 heading.',
                keywordInH2: 'Use the keyword in at least one H2 heading.',
                keywordInH3: 'Use the keyword in at least one H3 heading.',
                relatedKeywords: 'Work related keywords from the analysis into headings and paragraphs.',
                inboundLinks: 'Add an internal link to a related page on your site.',
                outboundLinks: 'Add a link to a trustworthy external source (not a competitor).',
                inspirationFromTopTen: 'Open inspiration from top content under a heading and fill the missing topics.',
                subHeadingDistribution: 'Every section with text should have a subheading to break up long paragraphs.',
                paragraphLength: 'Split paragraphs longer than 150 words so the text is easier to read.',
                sentenceLength: 'Keep sentences under 20 words so the article is easier to understand.',
            }
        }
    },

    articleTable: {
        selectedKeyword: 'Main keyword',
        url: {
            header: {
                text: 'URL of the published article',
                tooltip: 'Enter the URL of the article to find out the organic position on Google and the SEO score of the domain.'
            },
            dialog: {
                title: {
                    add: 'Add URL',
                    edit: 'Edit URL',
                },
                placeholder: 'https://www.example.com/path-to-article',
                errors: {
                    couldNotSave: 'Could not save the URL of the article. Please try again.',
                }
            },
            tooltip: {
                add: 'Add URL of the article',
                edit: 'Edit URL of the article',
            }
        },
        createdAt: 'Created',
        position: {
            found: '✅ <strong>Found!</strong> Your page is used as a <strong>source</strong> in the AI response',
            notFound: '❌ <strong>Not found</strong>. Your page was not cited in the AI response',
            sourcePosition: "<strong>Source position</strong>: You are displayed as <strong>{0}. source (link)</strong>",
            citedTitle: "Cited title",
            citedText: "Cited text",
        },
        organicPosition: {
            header: 'Google Organic position',
            tooltip: "Find out the position of the article in organic search results on Google. This information is only for informational purposes and does not guarantee the actual position of the article.",
        },
        googleAIOPosition: {
            header: 'Google AI Overview position',
            tooltip: "Find out the position of the article in organic search results on Google AI. This information is only for informational purposes and does not guarantee the actual position of the article.",
        },
        chatGPTPosition: {
            header: 'ChatGPT position',
            tooltip: "Find out the position of the article ChatGPT search results. This information is only for informational purposes and does not guarantee the actual position of the article.",
        },
        reloadableChip: {
            remeasure: 'Remeasure',
            cooldown: 'Remeasure is available in {0} hours and {1} minutes',
            errors: {
                unexpectedError: 'An unexpected error has occurred. Please try again.',
            },
            error: 'Error',
        },
        seoScore: 'Article SEO score',
        domainSeoScore: {
            header: {
                text: 'Domain SEO score',
                tooltip: 'Find out the SEO score of the domain where the article is published.'
            },
            tooltip: 'Open in new window',
        },
        edit: 'Improve article',
    },

    articleCrossroad: {
        newContent: {
            header: 'New content',
            description: 'Generate new content for website or blog',
            button: 'Create new content',
        },
        existingContent: {
            header: 'Existing content',
            description: 'Improve the content published on the URL',
            button: 'Analyze existing content',
        }
    },

    inspirationsError: {
        title: 'Error while getting inspirations.',
    },

    clipboardError: {
        title: 'Error while copying to clipboard.',
    },

    stripeError: {
        title: 'Error during communication with payment gateway.',
    },

    errors: {
        requiredField: "This field is required.",
        maxWords: "Maximum length is {0} words!",
        minLength: "You must fill at least {length} letters.",
        startsWithProtocol: "URL must start with http:// or https://",
        invalidUrl: "Invalid URL",
    },

    themeCustomizer: {
        title: 'Appearance settings',
        subtitle: 'Customize and preview changes in real time',
        theming: 'Theming',
        primaryColor: 'Primary color',
        theme: 'Theme',
        skin: 'Card style',
        reset: 'Reset to defaults',
        customColor: 'Custom color',
        colors: {
            blue: 'SEOWRITEE blue',
            green: 'SEOWRITEE green',
            violet: 'Violet',
            cyan: 'Cyan',
            orange: 'Orange',
            red: 'Red',
        },
        themes: {
            light: 'Light',
            dark: 'Dark',
            system: 'System',
        },
        skins: {
            default: 'Default',
            bordered: 'Bordered',
        },
    },

    share: {
        copy: 'Share preview',
        copied: 'Link copied',
        tooltip: 'Send this link to anyone. They will see the article 1:1, can click through the SEO menu, and live actions stay off.',
        copiedTitle: 'Preview link copied',
        copiedBody: 'The recipient will see the analysed article. Generate, analyse and edits stay off in the preview.',
        errorTitle: 'Could not create the link',
        errorBody: 'Try again, or save the article first.',
        bannerTitle: 'This is a shared article preview',
        bannerBody: 'You are looking at the analysed article 1:1. The SEO menu on the left is clickable. Generate, analyse, save and AI Lucy stay off.',
        drawerHint: 'Live actions are off in this preview. Register to run this on your own article.',
        register: 'Register and try it on your article',
        openOwn: 'Back to my articles',
        missingTitle: 'This preview is no longer available',
        missingBody: 'The link is invalid or was removed. Create an account and analyse your own article.',
        revoke: 'Stop sharing',
        revokeConfirmTitle: 'Stop sharing this preview?',
        revokeConfirmBody: 'The link you sent will stop working. Share preview creates a new link.',
        revokeConfirm: 'Stop sharing',
        revokeCancel: 'Keep it',
        revokedTitle: 'Sharing stopped',
        revokedBody: 'The old link no longer works.',
        revokeErrorTitle: 'Could not stop sharing',
        revokeErrorBody: 'Try again in a moment.',
    },

    loginMenu: {
        intro: 'See how an article scores for search and AI chats — before you sign in.',
        scoreHint: 'The score shows what the article is missing. Click a colour, then a factor.',
        factorHint: 'After you sign in, AI Lucy takes you to the place in the editor.',
        lucyTitle: 'AI Lucy',
        lucyBody: 'From live AI answers she builds what the article still needs to be cited. For each factor she shows the next step.',
        stepsTitle: 'From brief to export',
        briefTitle: 'Brief and AI template',
        briefBody: 'Topic, market and template: Google AI Overviews, Gemini, ChatGPT, Perplexity or Copilot. AI Lucy adds follow-ups and facts that get cited.',
        keywordsTitle: 'Keywords and AI questions',
        keywordsBody: 'Search phrases, questions from AI Overviews and chats, long-tail and difficulty. You pick what the article will carry.',
        writingTitle: 'Copy that can be cited',
        writingBody: 'A direct answer, FAQ, E-E-A-T and an AI visibility estimate. Then export to DOCX or HTML.',
        samples: {
            1: 'POS system',
            2: 'restaurant till',
            3: 'checkout software',
        },
        cta: 'Sign in and try it',
    },

    lucy: {
        name: 'AI Lucy',
        ask: 'Ask AI Lucy',
        askMore: 'Ask AI Lucy',
        askAbout: 'Explanation from AI Lucy',
        goThere: 'Go',
        goToNamed: 'Go to: {0}',
        presetsLabel: 'AI Lucy can answer now',
        presets: {
            next: 'What should I fix now?',
            aiVisibility: 'Explain the AI visibility estimate',
            redList: 'Which factors are critical?',
            cite: 'What should I write so AI cites this?',
        },
        contextLine: 'Score {0}% · {1} critical',
        noArticle: 'Open an article so AI Lucy can see the context',
        helloEmpty: 'Open an article. Then I will tell you what lifts SEO and AI visibility the most.',
        helloDone: 'Score {0}%. Nothing critical — you can polish and publish.',
        helloWork: 'Score {0}%. Next step: {1}.',
        redListBody: 'Critical now: {0}. Start with the first — AI Lucy will take you there.',
        noReds: 'No critical factors. You can tidy warnings or publish.',
        done: '{0} is already met. AI Lucy has nothing to add here.',
        phaseNote: 'AI Lucy writes texts from the brief and the analyses, and is your guide in the article. She advises what will most raise the SEO score and AI visibility, and shows the place in the editor.',
        nudgeTitle: 'AI Lucy recommends',
        nudgeBody: 'Next step: {0}',
        coach: {
            aiVisibility: {
                body: 'You will not fix AI visibility with one sentence in the intro. The first unfulfilled point is: {0}. That is the fastest way to become citable.',
                ok: 'FAQ, schema, author, intro and links look fine for AI visibility. AI Lucy has no priority fix here.',
            },
            faqPresent: 'Add at least one question and answer. AI Overviews treat FAQ as a citable passage — more than a longer intro.',
            faqFromBrief: 'From live AI questions, cover at least: {0}. A short FAQ answer cites better than a longer intro.',
            introFromBrief: 'Rewrite the intro as the direct answer AI currently gives — first 40–60 words, concrete facts, no filler.',
            citeEmpty: 'Once AI Lucy loads live AI chat answers, she will tell you which questions and entities belong in the article. For now, add an FAQ with a direct answer.',
            citeBody: 'To make the article citable in AI chats: answer {0}. Name entities {1}. The intro must stand alone as a quotable passage.',
            citeNoQuestions: 'questions from AI Overview and chat',
            citeNoEntities: 'specific names, products and methods',
            schemaMarkup: 'JSON-LD is not visible text. Improve writes it into the code. You can inspect it in preview on the Schema tab.',
            eatAuthor: 'Name the author before the snippet. Google and AI answers treat a byline as a trust signal.',
            eatDate: 'Add a published or updated date. Without a date the article looks unmaintained.',
            eatBio: 'Write two sentences about the author’s practice. A short bio lifts E-E-A-T more than a generic intro line.',
            eeatScore: 'E-E-A-T here is author, date, bio and trustworthy links. Start with the author name if it is missing.',
            keywordInIntroduction: 'Put the focus keyword in the first paragraph so the article answers the query immediately.',
            keywordInH1: 'The H1 heading is missing the main keyword. Add it, ideally at the beginning.',
            keywordInH2: 'The keyword is not in any H2 yet. Use it in at least one.',
            keywordInH3: 'The keyword is not in any H3 yet. Use it in at least one.',
            outboundLinks: 'Add a link to a trustworthy source in the article body — not in the tips block. Skip competitor URLs.',
            inboundLinks: 'Add an internal link to a related page on your site inside a paragraph.',
            keywordVariants: 'Find variants in keyword analysis under related. Pick 2–3 and use them in headings or paragraphs.',
            keywordDensity: 'Tune density in the left menu under keywords. Too few and too many occurrences both hurt.',
            serpIsComplete: 'The snippet is built from meta title and description. Fill both — the preview under the fields shows what Google sees.',
            imgAltIncludesKeyword: 'Add an image alt with the keyword. An empty alt is skipped by Google and by screen readers.',
            keywordInSlug: 'The URL should include the focus keyword. On a live page, plan a redirect.',
        },
    },

    topBar: {
        articles: 'Articles & Ranking',
        articlesLine1: 'Articles',
        articlesLine2: '& ranking',
        saveLine1: 'Save',
        saveLine2: 'article',
        detailedSeoScore: 'Improve SEO score',
        seoParams: 'SEO Parameters',
        thisArticle: 'This article',
        manual: 'Manual',
        blog: 'Blog',
        promo: 'Book a meeting',
        settingsTooltip: 'Workspace settings',
    },
    checkOutFeatures: "Check out what SEOWRITEE can do for you!",

    aiBrief: {
        title: 'Brief from AI chat answers',
        subtitle: 'Answer shape and live AI chat answers AI Lucy uses to write a citable article. LSI terms are in variations, questions in keyword analysis.',
        loading: 'AI Lucy is loading how search and AI chats currently answer this topic…',
        loadingAria: 'Loading…',
        loadingMore: 'Loading live AI chat answers…',
        loadingHeader: 'Loading intent and answer shape…',
        empty: 'There are no live AI chat answers for this topic yet. You can still generate the article from the selected keywords.',
        emptyLiveAnswer: 'There is no live answer from this AI chat yet.',
        connectionError: 'Could not reach the live AI chat answers service (connection or permission error). Try reloading the page.',
        keepShape: 'Use this shape when writing',
        keepShapeOn: 'Shape will be used when writing',
        keepShapeTip: 'Saves an instruction for AI Lucy to write the article in this shape (definition, steps, list…). The text in the editor is not overwritten.',
        keepShapeOnTip: 'The instruction is already on: AI Lucy will keep this shape. Clicking again does not change the article.',
        intentTip: 'Detected search intent AI Lucy uses to structure the article.',
        shapeChipTip: 'Answer shape search and AI chats currently use for this query.',
        templateChipTip: 'Structure template AI Lucy currently has set.',
        useOverviewTemplate: 'Write as AI Overview',
        useOverviewTemplateTip: 'Sets the AI Overviews template and tells AI Lucy to keep the answer shape. The card text is not pasted into the article.',
        useGeminiTemplate: 'Write as Gemini',
        useGeminiTemplateTip: 'Sets the Gemini template and tells AI Lucy to keep the answer shape. The card text is not pasted into the article.',
        usePerplexityTemplate: 'Write as Perplexity',
        usePerplexityTemplateTip: 'Sets the Perplexity template, tells AI Lucy to keep the answer shape, and jumps to the H2s so you can check the facts. The card text is not pasted.',
        useChatGptTone: 'Use ChatGPT tone',
        useChatGptToneTip: 'Sets the ChatGPT tone (friendly and clear) for AI Lucy. The scraped article is not overwritten and the card text is not pasted.',
        lsiInserted: 'Selected LSI keywords are in the intro and the density list.',
        nothingToInsert: 'The selected terms are already in the copy.',
        avatarTooltip: 'The avatar button opens the AI Lucy panel.',
        avatarAria: 'Open the AI Lucy panel',
        inH2: 'already an H2',
        factInserted: 'The sentence is in the article intro',
        factExists: 'This is already in the article — jumped to it',
        headingInIntro: 'The topic is in the intro',
        headingAdded: 'Added an H2 heading',
        headingExists: 'This H2 is already in the article',
        shapeKept: 'The answer shape will be used when writing. The scraped article was not overwritten.',
        templateAndShapeApplied: 'The template is set and AI Lucy will use the answer shape when writing. The scraped article was not overwritten.',
        layerLive: 'Live AI chat answers',
        layerKeywords: 'Keywords',
        answersHint: 'The "Work information in" button inserts the facts into the article and does not insert the full answer',
        expandAnswer: 'Show full answer',
        collapseAnswer: 'Collapse',
        toH2: 'Add H2',
        toH2Tip: 'The "Add H2" button adds the question as an H2 heading in the editor and checks it for AI Lucy. If it is already there, jumps to it.',
        toFaq: 'Add FAQ',
        toFaqTip: 'The "Add FAQ" button adds the question to the FAQ in the editor and checks it for AI Lucy.',
        inFaq: 'in FAQ',
        inFaqTip: 'This question is already in the FAQ. Click to remove it from the FAQ.',
        inH2Tip: 'This H2 is already in the article. Click jumps to it.',
        addToText: 'Weave into text',
        addToTextTip: 'AI Lucy weaves the phrase into existing parts without a new subheading — not counted toward the 20 paragraph limit.',
        alreadyInIntro: 'already in the intro',
        alreadyInIntroTip: 'This term is already in the article. Click will not insert it again.',
        workIn: 'Work information in',
        workInTip: 'The "Work information in" button inserts the facts into the article and does not insert the full answer',
        workedIn: 'Worked in',
        workedInTip: 'Information from this answer is already worked into the article.',
        workInDone: 'Facts from this answer are now in the article. The full transcript was not pasted.',
        workInNothing: 'This answer has no new facts that are not already in the article.',
        useTemplateTip: 'Switches the article structure template to the recommended one. The text in the editor is not overwritten.',
        expandAnalysisTip: 'Opens the keyword groups. Questions are in Questions, LSI in Variants and LSI.',
        collapseAnalysisTip: 'Collapses the keyword tables.',
        keepTone: 'Use ChatGPT tone',
        checkFacts: 'Write as Perplexity',
        templateUsed: 'in use',
        recommended: 'Recommended',
        expandAnalysis: 'Expand analysis',
        collapseAnalysis: 'Collapse analysis',
        analysisMeta: '{0} groups · {1}/{2} for AI Lucy · collapsed',
        analysisMetaOpen: '{0} groups · {1}/{2} for AI Lucy',
        toneApplied: 'Tone is set. The scraped article stays until Enhance or a manual edit.',
        templateHint: 'From intent and AI answers, AI Lucy recommends the {0} template.',
        useTemplate: 'Use template',
        intent: {
            informational: 'Intent: explain',
            navigational: 'Intent: find a destination',
            commercial: 'Intent: compare and choose',
            transactional: 'Intent: act / buy',
        },
        shape: {
            definition: 'Result shape: definition',
            steps: 'Result shape: steps',
            list: 'Result shape: list',
            table: 'Result shape: table',
            comparison: 'Result shape: comparison',
        },
        platforms: {
            googleAio: 'AI Overview',
            chatgpt: 'ChatGPT',
            gemini: 'Gemini',
            claude: 'Claude',
            perplexity: 'Perplexity',
        },
        sources: {
            paa: 'from search',
            related: 'related',
            fanout: 'follow-up',
            mentions: 'from AI chat',
            forums: 'forums',
            labs: 'suggestion',
            lsi: 'LSI',
            pas: 'PAS',
            organicFaq: 'from TOP page FAQ',
            autocomplete: 'autocomplete',
        },
        citedSources: 'Sources AI cites',
        citedSourcesHint: 'Links AI chats used as sources. Select them for AI Lucy — they become optional outbound citations (E-E-A-T).',
        citeForLucy: 'Select for AI Lucy',
        citeForLucyTip: 'The "For AI Lucy" button adds this source to the brief as an optional outbound citation.',
        citedSelected: 'mention as a source',
        citedSelectedTip: 'AI Lucy will mention this source as a citation. Click to deselect.',
        insertHint: 'insert hint into FAQ',
        insertHintTip: 'Puts the People also ask hint into the FAQ answer. It is not dumped into the article without a click.',
    },
};
